<template>
	<div class="finance container-fluid py-2">
		<div class="row">
			<div class="col-md-12 p-0">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span style="font-size:30px;"><strong>Pertamina Mandalika GP {{ tahun }} </strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:-21px;">   
							<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<MandalikaGPReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>
import Bright from '@/components/page/Bright.js'
import MandalikaGPReportTab from '@/views/pages/MandalikaGPReportTab.vue'
import { Rainbow, Rainbow2, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'

export default
{
	extends: Bright,
	components: { 
		MandalikaGPReportTab,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			tabList:[
				{label:'Summary', name: 'mandalika1', index: '0' },
				{label:'Nett Sales', name: 'mandalika2', index: '1' },
				{label:'Sales Per Item', name: 'mandalika3', index: '2' },
				{label:'Sales Per Category', name: 'mandalika4', index: '3' },
				{label:'Sales Per Payment Method', name: 'mandalika5', index: '4' },
				{label:'Summary Race Day', name: 'mandalika6', index: '5' },
			],
			tahun: Penanggalan().tahun,
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>